// extracted by mini-css-extract-plugin
export var deliveryRow = "_p0-a";
export var fixedHeight = "_p0-4";
export var freightLogo = "_p0-9";
export var fullWidth = "_p0-3";
export var priceColumn = "_p0-5";
export var radioSelected = "_p0-7";
export var radioUnselected = "_p0-6";
export var selectedOption = "_p0-2";
export var selectedOptionContainer = "_p0-1";
export var selection = "_p0-0";
export var tallSkeletonText = "_p0-8";